export class CredentialDefinitionUsageReport {
  public associatedCount: number;
  public isUsed: boolean;

  constructor(data: any) {
    this.isUsed = data.isUsed;
    this.associatedCount = data.associatedCount;
  }
}
